import { AssessmentOverviewFormField } from '../sections/assessment-overview/formField'
import { FinalStepsFormField } from '../sections/final-steps/formField'
import { SupervisoryReviewFormField } from '../sections/supervisory-review/formField'
import { VitalsFormField } from '../sections/vitals/formField'
import { AuthorizationFormField } from '../sections/authorization/formField'
import { PlanOfCareFormField } from '../sections/planOfCare/formField'
import { VisitSchedulingFormField } from '../sections/visit-scheduling/formField'
import { MedicationsFormField } from '../sections/medications/formField'
import { ResumptionOverviewFormField } from '../sections/resumption-overview/formField'
import { MedicalBackgroundFormField } from '../sections/medical-background/formField'
import { SkilledNeedsFormField } from '../sections/skilled-needs/formField'
import { DischargePlanningFormField } from '../sections/discharge-planning/formField'
import { NarrativeFormField } from '../sections/narrative/formField'
import { ADLNeedFormField } from '../sections/adls-needs/formField'

export const RocFormField = {
  ...AssessmentOverviewFormField,
  ...SupervisoryReviewFormField,
  ...VitalsFormField,
  ...DischargePlanningFormField,
  ...AuthorizationFormField,
  ...VisitSchedulingFormField,
  ...FinalStepsFormField,
  ...PlanOfCareFormField,
  ...MedicationsFormField,
  ...ResumptionOverviewFormField,
  ...MedicalBackgroundFormField,
  ...SkilledNeedsFormField,
  ...NarrativeFormField,
  ...ADLNeedFormField
} as const

export type RocFormField = (typeof RocFormField)[keyof typeof RocFormField]
